exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".box[data-v-2846f69d]{background:no-repeat 0 0 / cover;cursor:zoom-in}\n", ""]);

